import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FieldArrayType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TableLayoutMetadata } from '../../../../model/dyn-form/form-metadata/layout/table-layout-metadata.model';
import { RowLayoutMetadata, RowLayoutMetadataBase } from '../../../../model/dyn-form/form-metadata/layout/row-layout.metadata.model';
import { QuillModule } from 'ngx-quill';
import { MatCheckboxModule } from '@angular/material/checkbox';

interface FieldToRenderStruct {
    name: string
    key: string
    type: string
    order: number
}

@Component({
    selector: 'app-table-type',
    templateUrl: './table-type.component.html',
    styleUrl: './table-type.component.scss',
    standalone: true,
    imports: [
        CommonModule, ReactiveFormsModule, FormlyModule, QuillModule,
        MatTableModule, MatCardModule, MatIconModule, MatButtonModule, MatCheckboxModule
    ]
})
export class TableTypeComponent extends FieldArrayType implements OnInit {

    @ViewChild("formTable", { static: true }) table!: MatTable<any>

    public dataSource: MatTableDataSource<FormlyFieldConfig> = new MatTableDataSource();

    ngOnInit(): void {
        this.dataSource.data = <FormlyFieldConfig[]>this.field.fieldGroup
        if (this.metadata().atLeastOne) {
            super.add()
        }
    }

    override add($event: any) {
        let field: any = this.field
        if (field['metadata'] == null) {
            super.add()
            $event.stopPropagation()
            return
        }

        let tlm: TableLayoutMetadata = field['metadata']
        let obj: any = {}

        tlm.items.forEach(item => {
            let row = <RowLayoutMetadata>item;
            row.items.forEach(widget => {
                obj[widget.fieldName] = widget.defaultValue;
            });
        })

        super.add(this.formControl.length, obj)
        this.table.renderRows()
        $event.stopPropagation()
    }

    override remove($event: any) {
        super.remove($event)
        this.table.renderRows()
    }

    metadata(): TableLayoutMetadata {
        let field: any = this.field
        if (field['metadata'] == null) {
            return <TableLayoutMetadata>{
                name: "unm"
            }
        }
        return field['metadata']
    }

    checkTableStatus(status: boolean) {

        if (this.metadata().atLeastOne) return

        if (status && this.dataSource.data.length == 0) {
            super.add()
            return
        }

        if (!status && this.dataSource.data.length > 0) {
            for(let i = this.dataSource.data.length; i > 0; i--) {
                this.remove(i - 1)
            }
        }

    }

    getDisplayColumns(): string[] {

        if (this.dataSource.data.length == 0) return []

        let headerColumns: string[] = []
        this.metadata().items.forEach(r => {
            if (r.type == "ROW_LAYOUT") {
                const row: RowLayoutMetadata = r as any
                row.items.forEach(i => {
                    headerColumns.push(i.id)
                })
            }
        })
        return [...headerColumns, 'delete']
    }

    getFields(): FormlyFieldConfig[] {
        return this.field?.fieldGroup?.[0]?.fieldGroup?.[0]?.fieldGroup ?? [];
    }

    getFieldById(row: any, id: string): FormlyFieldConfig {
        return row.fieldGroup[0]?.fieldGroup.find((field: FormlyFieldConfig) => field.id === id);
    }

}
